import React from "react";
import {Table} from 'antd';
import {tblColsHistory} from "../../../../../config/Helpers";


class BudgetList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            }
    }

    // ----------------------- Handlers -----------------------

    // ----------------------- Functions -----------------------

    // ----------------------- Renders -----------------------

    render() {
        return (

            <div className="box regular col-md-12">
                <h3>Budget history</h3>
                <div className="table-in-box"><br />
                    <div className="ant-container">

                    <Table columns={tblColsHistory} dataSource={this.props.app.state.budget_lst_rows  } scroll={{ x: 1300 }} />
                    </div>
                </div>
            </div>
            
        );

    }

}


export default BudgetList


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/budget/BudgetList.js